<script setup>
import { computed, onMounted, ref } from "vue";
const props = defineProps({
    link: { type: Object, required: true },
    appearance: { type: Object, default: () => ({}) },
    buttonStyle: { type: [Object, Array, String], default: () => ({}) },
    DoBucket: String,
    DoEndpoint: String,
    layout: { type: String, default: "classic" }, // can still pass for consistency
});

const emit = defineEmits(["click"]);

const currentEffect = computed(() => {
    try {
        const p = props.link?.options?.prioritize;
        if (p?.type === "animation" && p?.animation_effect)
            return String(p.animation_effect);
        return "";
    } catch (e) {
        return "";
    }
});

const initialAnimateClass = ref("");
const onAnimEnd = () => {
    initialAnimateClass.value = "";
};

onMounted(() => {
    if (currentEffect.value)
        initialAnimateClass.value = `${currentEffect.value}-animate`;
});
</script>

<template>
    <button
        :id="link.id"
        @click="emit('click', link)"
        class="btn align-items-center justify-content-between position-relative w-100 link-button"
        :class="[
            appearance.buttons || 'btn-light',
            appearance.button_margin_top || 'mt-0',
            link?.options?.prioritize?.type === 'animation' &&
            link?.options?.prioritize?.animation_effect
                ? link.options.prioritize.animation_effect
                : '',
            initialAnimateClass,
            link?.options?.prioritize?.type === 'spotlight' ? 'spotlight' : '',
            layout, // CSS
            { 'embed-button': link?.options?.layout === 'featured' },
        ]"
        @animationend="onAnimEnd"
        :style="[
            buttonStyle,
            {
                '--hover-bg': appearance.button_background_hover || '#eee',
                '--hover-text': appearance.button_hover_color || '#fff',
                '--hover-transform': appearance.transform || 'scale(1.02)',
            },
        ]"
    >
        <!-- Slot replaces featured/classic layouts -->
        <slot />
    </button>
</template>

<style scoped>
/* Keep shared styles if needed */
.featured-wrap {
    overflow: hidden;
}
.featured-bottom {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: inherit !important;
    border-bottom-right-radius: inherit !important;
}
.classic-icon {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 6px;
    flex-shrink: 0;
}
.center {
    max-width: calc(100% - 80px);
}
.classic-title {
    display: block;
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.3;
    font-size: 15px;
}
.featured-title {
    font-size: 15px;
    line-height: 1.4;
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
}
</style>
